export default __webpack_public_path__ + "static/su-c434981163d419d6daf20b511d714104.webp";